var _title;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFancyQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25.66,
  height: 19.45,
  viewBox: "0 0 25.66 19.45",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "fancyQuote")), /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,2.06C9.08,3.46,6.77,6,6.87,9a5.05,5.05,0,0,1,4.57,5.26,5.42,5.42,0,0,1-5.36,5.2,5.88,5.88,0,0,1-6-5.28C-.65,9.53,2.3,3,10.9,0,11.43,1,12,2.06,12,2.06Z",
  style: {
    fill: "#c9f414"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.66,2.06C22.71,3.46,20.4,6,20.5,9a5.05,5.05,0,0,1,4.57,5.26,5.42,5.42,0,0,1-5.35,5.2,5.88,5.88,0,0,1-6-5.28C13,9.53,15.93,3,24.53,0,25.06,1,25.66,2.06,25.66,2.06Z",
  style: {
    fill: "#c9f414"
  }
}))));
export default SvgFancyQuote;